module.exports = __webpack_public_path__ + "static/media/type-exercise.c074342e.mov";